// This file is automatically generated. Do not edit manually.

import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace ProjectActivityMaterialActionApi {
	export async function cancelMaterials(args: { projectActivityMaterialIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityMaterials/cancelMaterials",
			method: "POST",
			data: {
				projectActivityMaterialIds: args.projectActivityMaterialIds,
			},
		});
		return response as void;
	}

	export async function releaseMaterials(args: { projectActivityMaterialIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityMaterials/releaseMaterials",
			method: "POST",
			data: {
				projectActivityMaterialIds: args.projectActivityMaterialIds,
			},
		});
		return response as void;
	}

	export async function unpackConfiguration(args: { projectActivityMaterialIds: Array<number> }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityMaterials/unpackConfiguration",
			method: "POST",
			data: {
				projectActivityMaterialIds: args.projectActivityMaterialIds,
			},
		});
		return response as void;
	}

	export async function revertUnpackConfiguration(args: { projectActivityMaterialId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/project/activityMaterials/revertUnpackConfiguration",
			method: "POST",
			data: {
				projectActivityMaterialId: args.projectActivityMaterialId,
			},
		});
		return response as void;
	}
}
